import { AppUser } from 'Src/views/App/App';
import { Child } from 'Src/models/child';
import { getChildren } from 'Src/helpers/service/parent/children';
import { getParentProgrammeBookingInbox } from 'Src/helpers/service/parent/clubProgrammesBooking';
import { ProgrammeBookingInboxItem } from 'Src/views/GenericView/components/ClubProgrammes/ProgrammeBooking/ProgrammeBooking.types';

export type ParentClubProgrammesLoadResult = {
  childNameByPermId: Map<string, string>;
  flatItems: ProgrammeBookingInboxItem[];
};

export async function loadParentClubProgrammesData(
  user: AppUser,
  knownChildren?: Child[]
): Promise<ParentClubProgrammesLoadResult> {
  const children = Array.isArray(knownChildren) ? knownChildren : await getChildren(user);

  const childNameByPermId = new Map<string, string>(
    (children || []).map((c: any) => [String(c.permissionId), `${c.firstName} ${c.lastName}`.trim()])
  );

  const schoolToPermIds = new Map<string, string[]>();
  (children || []).forEach((c: any) => {
    const schoolId = String(c.schoolId || '');
    const permId = String(c.permissionId || '');
    if (!schoolId || !permId) return;

    if (!schoolToPermIds.has(schoolId)) schoolToPermIds.set(schoolId, []);
    schoolToPermIds.get(schoolId)!.push(permId);
  });

  const schoolIds = Array.from(schoolToPermIds.keys());
  if (!schoolIds.length) {
    return {
      childNameByPermId,
      flatItems: []
    };
  }

  const perSchool = await Promise.all(
    schoolIds.map(async schoolId => {
      try {
        return await getParentProgrammeBookingInbox(user, schoolId);
      } catch (e) {
        return [];
      }
    })
  );

  const flatItems: ProgrammeBookingInboxItem[] = ([] as ProgrammeBookingInboxItem[]).concat(...perSchool);

  return {
    childNameByPermId,
    flatItems
  };
}
